import React from 'react'
import ViewClients from './pages/viewClients/ViewClients'
import { Route, Routes } from 'react-router-dom'
import CreateClient from './pages/createClient/CreateClient'
import EditClient from './pages/editClient/EditClient'

const Clients = () => {
  return (
    <div>
        <Routes>
            <Route path="/" element={<ViewClients />} />
            <Route path="/create" element={<CreateClient />} />
            <Route path="/edit" element={<EditClient />} />
        </Routes>
    </div>
  )
}

export default Clients